import { Eye } from "./eye";
import { Edit } from "./edit";
import { Exit } from "./exit";
import { Menu } from "./menu";
import { Note } from "./note";
import { Plus } from "./plus";
import { Lock } from "./lock";
import { Home } from "./home";
import { Clock } from "./clock";
import { Minus } from "./minus";
import { Phone } from "./phone";
import { XMark } from "./x-mark";
import { Wallet } from "./wallet";
import { Filter } from "./filter";
import { Person } from "./person";
import { Remove } from "./remove";
import { Search } from "./search";
import { TurnUp } from "./turn-up";
import { AngleUp } from "./angle-up";
import { Calendar } from "./calendar";
import { EyeSlash } from "./eye-slash";
import { TurnDown } from "./turn-down";
import { AngleDown } from "./angle-down";
import { AngleLeft } from "./angle-left";
import { ArrowLeft } from "./arrow-left";
import { CheckMark } from "./check-mark";
import { AngleRight } from "./angle-right";
import { RotateRight } from "./rotate-right";
import { EllipsisVertical } from "./ellipsis-vertical";
import { OptionSign } from "./option-sign";
import { EmptyUnit } from "./emptyUnit";
import { Setting } from "./setting";
import { Pin } from "./pin";
import { CreditCard } from "./credit-card";
import { Reports } from "./reports";
import { Dashboard } from "./dashboard";
import { BasicData } from "./basic-data";
import { Facilities } from "./facilities";
import { Person2 } from "./person2";
import { Subject } from "./subject";
import { Call } from "./call";
import { Telegram2 } from "./telegram2";
import { WhatsApp2 } from "./whatsapp2";
import { Mail } from "./mail";
import { Location } from "./location";
import { Accessiblity } from "./Accessiblity";
import { Warning } from "./warning";
import { Bell } from "./bell";
import { Aboutus } from "./aboutus";
import { PersonOutlined } from "./person-outlined";
import { ReportDetail } from "./report-detail";
import { DownloadPdf } from "./download-pdf";
import { PdfBadge, PdfBadgeGrey } from "./pdf-badge";
import { SendSms } from "./send-sms";
import { SmsHistory } from "./sms-history";
import { PersonalSms } from "./personal-sms";
import { CreditDetail } from "./credit-detail";
import { PenaltyHistory } from "./penalty-history";
import { DownLoadArrow } from "./download-arrow";

import { Advertise } from "./advertise";
import { Tip } from "./tip";
import { DownloadDocument } from "./download-document";
import { Photo } from "./photo";
import { Upload } from "./uplaod";
import { TinyAngleLeft } from "./tiny-angle-left";
import { EditHistory } from "./edit-history";
import { Transaction } from "./transaction";
import { Statistics } from "./statistics";
import { Guest } from "./guest";
import { Enrollment } from "./enrollment";
import { Reserve } from "./reserve";
import { ReservationRequest } from "./ReservationRequest";
import { Survey } from "./survey";
import { Message } from "./Message";
import { GuestRequest } from "./guest-request";
import { ExcelBadge } from "./excelBadge";
import { CloseEye } from "./close-eye";
import { AddUser } from "./add-user";
import { MessageArrow } from "./message-arrow";
import { Link } from "./link";
import { DragHolder } from "./drag-holder";
import { RelationArrow } from "./relation-arrow";
import { Preview } from "./preview";
import { CRMRequest } from "./crm-request";
import { Percentage } from "./percentage";
import { Discount } from "./discount";
import { Restaurant } from "./restaurant";
import { AddDebt } from "./add-debt";
import { ArrowRight } from "./arrow-right";
import { Navigate } from "./navigate";
import { Instagram } from "./instagram";

export type IconPropsType = {
  size?: number;
  color?: string;
};

export type IconType =
  | "Eye"
  | "Edit"
  | "Exit"
  | "Menu"
  | "Note"
  | "Plus"
  | "Class"
  | "Coach"
  | "Lock"
  | "Home"
  | "Clock"
  | "Minus"
  | "Phone"
  | "XMark"
  | "Filter"
  | "Wallet"
  | "Person"
  | "Remove"
  | "Search"
  | "TurnUp"
  | "AngleUp"
  | "Warning"
  | "Calendar"
  | "Language"
  | "DownLoad"
  | "Whatsapp"
  | "Telegram"
  | "EyeSlash"
  | "TurnDown"
  | "AngleDown"
  | "AngleLeft"
  | "ArrowLeft"
  | "CheckMark"
  | "Instagram"
  | "AngleRight"
  | "RotateRight"
  | "SendMessage"
  | "OptionSign"
  | "EmptyUnit"
  | "Pin"
  | "Bell"
  | "Call"
  | "Mail"
  | "Person2"
  | "Reports"
  | "Subject"
  | "Setting"
  | "Location"
  | "BasicData"
  | "Dashboard"
  | "Telegram2"
  | "WhatsApp2"
  | "CreditCard"
  | "Facilities"
  | "Statistics"
  | "Enrollment"
  | "Accessiblity"
  | "DisableMessage"
  | "Message"
  | "EllipsisVertical"
  | "PrintIcon"
  | "Advertise"
  | "Aboutus"
  | "ReportDetail"
  | "Tip"
  | "DownloadDocument"
  | "PersonOutlined"
  | "PdfBadge"
  | "PdfBadgeGrey"
  | "DownloadPdf"
  | "SendSms"
  | "SmsHistory"
  | "PersonalSms"
  | "CreditDetail"
  | "Photo"
  | "Upload"
  | "EditHistory"
  | "Transaction"
  | "TinyAngleLeft"
  | "Guest"
  | "PenaltyHistory"
  | "Reserve"
  | "ReservationRequest"
  | "Survey"
  | "GuestRequest"
  | "ExcelBadge"
  | "CloseEye"
  | "AddUser"
  | "MessageArrow"
  | "Link"
  | "DragHolder"
  | "RelationArrow"
  | "Preview"
  | "CRMRequest"
  | "DownloadArrow"
  | "Percentage"
  | "Discount"
  | "Restaurant"
  | "AddDebt"
  | "ArrowRight"
  | "Navigate"
  | "DownloadArrow";

interface Props {
  name: IconType;
}

export type IconsProps = Props & IconPropsType;

export const Icons: React.FC<IconsProps> = (props) => {
  switch (props.name) {
    case "Eye":
      return <Eye {...props} />;
    case "Edit":
      return <Edit {...props} />;
    case "Exit":
      return <Exit {...props} />;
    case "Menu":
      return <Menu {...props} />;
    case "Note":
      return <Note {...props} />;
    case "Plus":
      return <Plus {...props} />;
    case "Lock":
      return <Lock {...props} />;
    case "Clock":
      return <Clock {...props} />;
    case "Home":
      return <Home {...props} />;
    case "Minus":
      return <Minus {...props} />;
    case "Phone":
      return <Phone {...props} />;
    case "XMark":
      return <XMark {...props} />;
    case "Filter":
      return <Filter {...props} />;
    case "Wallet":
      return <Wallet {...props} />;
    case "Person":
      return <Person {...props} />;
    case "Remove":
      return <Remove {...props} />;
    case "Search":
      return <Search {...props} />;
    case "TurnUp":
      return <TurnUp {...props} />;
    case "AngleUp":
      return <AngleUp {...props} />;
    case "Warning":
      return <Warning {...props} />;
    case "Calendar":
      return <Calendar {...props} />;
    case "EyeSlash":
      return <EyeSlash {...props} />;
    case "TurnDown":
      return <TurnDown {...props} />;
    case "AngleDown":
      return <AngleDown {...props} />;
    case "AngleLeft":
      return <AngleLeft {...props} />;
    case "ArrowLeft":
      return <ArrowLeft {...props} />;
    case "CheckMark":
      return <CheckMark {...props} />;
    case "Enrollment":
      return <Enrollment {...props} />;
    case "Statistics":
      return <Statistics {...props} />;
    case "Message":
      return <Message {...props} />;
    case "AngleRight":
      return <AngleRight {...props} />;
    case "RotateRight":
      return <RotateRight {...props} />;
    case "EllipsisVertical":
      return <EllipsisVertical {...props} />;
    case "OptionSign":
      return <OptionSign {...props} />;
    case "EmptyUnit":
      return <EmptyUnit {...props} />;
    case "Setting":
      return <Setting {...props} />;
    case "Pin":
      return <Pin {...props} />;
    case "CreditCard":
      return <CreditCard {...props} />;
    case "Reports":
      return <Reports {...props} />;
    case "Dashboard":
      return <Dashboard {...props} />;
    case "BasicData":
      return <BasicData {...props} />;
    case "Facilities":
      return <Facilities {...props} />;
    case "Person2":
      return <Person2 {...props} />;
    case "Subject":
      return <Subject {...props} />;
    case "Call":
      return <Call {...props} />;
    case "Telegram2":
      return <Telegram2 {...props} />;
    case "WhatsApp2":
      return <WhatsApp2 {...props} />;
    case "Mail":
      return <Mail {...props} />;
    case "Location":
      return <Location {...props} />;
    case "Accessiblity":
      return <Accessiblity {...props} />;
    case "Bell":
      return <Bell {...props} />;
    case "Advertise":
      return <Advertise {...props} />;
    case "Aboutus":
      return <Aboutus {...props} />;
    case "PersonOutlined":
      return <PersonOutlined {...props} />;
    case "ReportDetail":
      return <ReportDetail {...props} />;
    case "Tip":
      return <Tip {...props} />;
    case "DownloadDocument":
      return <DownloadDocument {...props} />;
    case "PdfBadge":
      return <PdfBadge {...props} />;
    case "PdfBadgeGrey":
      return <PdfBadgeGrey {...props} />;
    case "DownloadPdf":
      return <DownloadPdf {...props} />;
    case "SendSms":
      return <SendSms {...props} />;
    case "PersonalSms":
      return <PersonalSms {...props} />;
    case "CreditDetail":
      return <CreditDetail {...props} />;
    case "SmsHistory":
      return <SmsHistory {...props} />;
    case "Photo":
      return <Photo {...props} />;
    case "Upload":
      return <Upload {...props} />;
    case "TinyAngleLeft":
      return <TinyAngleLeft {...props} />;
    case "EditHistory":
      return <EditHistory {...props} />;
    case "Transaction":
      return <Transaction {...props} />;
    case "Guest":
      return <Guest {...props} />;
    case "PenaltyHistory":
      return <PenaltyHistory {...props} />;
    case "Reserve":
      return <Reserve {...props} />;
    case "ReservationRequest":
      return <ReservationRequest {...props} />;
    case "Survey":
      return <Survey {...props} />;
    case "GuestRequest":
      return <GuestRequest {...props} />;
    case "ExcelBadge":
      return <ExcelBadge {...props} />;
    case "DownloadArrow":
      return <DownLoadArrow {...props} />;
    case "CloseEye":
      return <CloseEye {...props} />;
    case "AddUser":
      return <AddUser {...props} />;
    case "MessageArrow":
      return <MessageArrow {...props} />;
    case "Link":
      return <Link {...props} />;
    case "DragHolder":
      return <DragHolder {...props} />;
    case "RelationArrow":
      return <RelationArrow {...props} />;
    case "Preview":
      return <Preview {...props} />;
    case "CRMRequest":
      return <CRMRequest {...props} />;
    case "Percentage":
      return <Percentage {...props} />;
    case "Discount":
      return <Discount {...props} />;
    case "Restaurant":
      return <Restaurant {...props} />;
    case "AddDebt":
      return <AddDebt {...props} />;
    case "ArrowRight":
      return <ArrowRight {...props} />;
    case "Navigate":
      return <Navigate {...props} />;
    case "Instagram":
      return <Instagram {...props} />;
    default:
      return <span>?</span>;
  }
};
